<template>
  <TheModalRequest :class="'modal-request-travel'">
    <ElementModal @close="closeModal">
      <h2 slot="header">{{ $t(`message.travels.request.title`) }}</h2>
      <div slot="body">

        <div class="modal-request-travel__info" v-if="error.start || error.end || error.destination || errorMessage">
          <div v-if="error.start">Invalid or empty start date</div>
          <div v-if="error.end">Invalid or empty end date</div>
          <div v-if="error.destination">Invalid or empty destination</div>
          <div v-if="errorMessage">{{ errorMessage }}</div>
        </div>

        <form id="travelRequest" @submit.prevent="submitForm">

          <!-- Start Date -->
          <ElementFormGroup :label="$t(`message.modal.request.startDate`)">
            <ElementFormDay placeholder="From" selected-value="morning" @change="handleStartDate" />
          </ElementFormGroup>

          <!-- End Date -->
          <ElementFormGroup :label="$t(`message.modal.request.endDate`)">
            <ElementFormDay placeholder="End" selected-value="afternoon" @change="handleEndDate" />
          </ElementFormGroup>

          <!-- Other CropLife staff -->
          <ElementFormGroup :label="$t(`message.modal.request.users`)">
            <ElementFormCheckboxList :prefix="'request-users'" :checkboxes="requestUsers" @change="handleUsers" />
          </ElementFormGroup>

          <!-- Destination -->
          <ElementFormGroup :label="$t(`message.modal.request.destination`)">
            <ElementFormText @change="handleDestination" />
          </ElementFormGroup>

          <!-- Purpose of travel -->
          <ElementFormGroup :label="$t(`message.modal.request.purpose`)">
            <ElementFormTextarea @change="handlePurpose" />
          </ElementFormGroup>

          <!-- Button -->
          <div class="form-group">
            <BaseSubmit :disabled="!allowSubmit">{{ $t(`message.modal.request.submit`) }}</BaseSubmit>
            <span>{{ $t(`message.modal.request.or`) }}</span>
            <a href="javascript:void(0)" class="button-cancel" @click="cancelForm()">{{ $t(`message.modal.request.cancel`) }}</a>
          </div>

        </form>
      </div>
    </ElementModal>
  </TheModalRequest>
</template>

<script>
import { fetchPostService } from '@modules/api'
import { mapGetters, mapActions } from 'vuex'
import BaseSubmit from '@base/BaseSubmit'
import ElementFormGroup from '@elements/ElementFormGroup'
import ElementFormDay from '@elements/ElementFormDay'
import ElementFormCheckboxList from '@elements/ElementFormCheckboxList'
import ElementFormText from '@elements/ElementFormText'
import ElementFormTextarea from '@elements/ElementFormTextarea'
import ElementModal from '@elements/ElementModal'
import TheModalRequest from './TheModalRequest'

export default {
  name: 'TheModaltravelRequest',
  components: {
    BaseSubmit,
    ElementModal,
    ElementFormGroup,
    ElementFormDay,
    ElementFormCheckboxList,
    ElementFormText,
    ElementFormTextarea,
    TheModalRequest
  },
  props: {
    submit: {
      type: String,
      required: false
    },
    content: {
      type: Object,
      required: false
    }
  },
  // watch: {
  //   modalName () {}
  // },
  data () {
    return {
      allowSubmit: false,
      error: {
        start: false,
        end: false,
        destination: false
      },
      start: {
        date: '',
        moment: ''
      },
      end: {
        date: '',
        moment: ''
      },
      destination: '',
      users: [],
      allSelected: false,
      purpose: '',
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      name: 'modal/getName',
      requestUsers: 'travels/getRequestUsers'
    }),
    showModal () {
      return this.name === 'travel'
    }
  },
  watch: {
    start: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    },
    end: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    },
    destination: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      updateName: 'modal/updateName',
      fetchGetPage: 'page/fetchGetPage'
    }),
    handleCheckboxChange (checkboxes) {
      this.travelRequest.checkedMembers = [ ...checkboxes ]
    },
    closeModal () {
      this.updateName('')
    },
    submitForm () {
      this.error.start = this.start.date === ''
      this.error.end = this.end.date === ''
      this.error.destination = this.destination === ''

      if (!this.error.start && !this.error.end && !this.error.destination) {
        fetchPostService('travels-request', {
          start: { ...this.start },
          end: { ...this.end },
          destination: this.destination,
          users: [ ...this.users ],
          purpose: this.purpose
        })
          .then(({ data }) => {
            this.errorMessage = ''
            if (data.error && !data.success) {
              this.errorMessage = data.error
            } else {
              this.fetchGetPage({ service: 'travels' }).then(() => {
                this.closeModal()
              })
            }
          })
      }
    },
    cancelForm () {
      this.updateName('')
    },
    handleStartDate (object) {
      this.start = { ...object }
    },
    handleEndDate (object) {
      this.end = { ...object }
    },
    handleUsers (array) {
      this.users = [ ...array ]
    },
    handleDestination (string) {
      this.destination = string
    },
    handlePurpose (string) {
      this.purpose = string
    },
    checkSubmitAvailability () {
      this.allowSubmit = this.start.date !== '' && this.end.date !== '' && this.destination !== ''
    }
  }
}
</script>

<style lang="scss">
.modal-request-travel{
  &__info{
    @include form-info-error;
  }
}
</style>
